import styled from "@emotion/styled"
import { SyncItemStatus } from "@fusion-advantage/formlib"
import { StatusIndicatorContext, syncStatusIndicatorProps } from "./StatusIndicatorProps"
import { V2L1StatusIndicator } from "./V2L1StatusIndicator"

// in this case we have a custom root so that the parent grid
// can lay out the icon and title separately
const V2L1SyncModalItemRoot = styled.div({
	display: 'contents',
	fontWeight: 600,
})

interface V2L1SyncItemIndicatorProps {
	name: string
	status: SyncItemStatus
}

export const V2L1SyncItemIndicator = ({name, status}: V2L1SyncItemIndicatorProps) => {
	const props = syncStatusIndicatorProps(status, StatusIndicatorContext.Modal)
	return (
		<V2L1SyncModalItemRoot>
			<V2L1StatusIndicator icon={props.icon} color={props.color} />
			<div>{name}</div>
		</V2L1SyncModalItemRoot>
	)
}
